<template>
  <div
    v-if="entries.length"
    class="price-breakdown"
  >
    <div
      v-for="(entry, index) in entries"
      :key="`${entry.group}-${index}-${entry.label}`"
      class="price-breakdown__row"
    >
      <span>
        <strong v-if="entry.group">{{ entry.group }}:</strong>
        {{ entry.label }}
      </span>
      <span
        v-if="entry.amount !== null"
        class="price-breakdown__amount"
      >
        {{ formatAmount(entry.amount) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceBreakdown',
  props: {
    priceBreakdown: { type: [Array, Object, String], default: null },
    childBreakdown: { type: [Array, Object, String], default: null },
    daily: { type: [Array, Object], default: null },
    includeDaily: { type: Boolean, default: false },
  },
  computed: {
    entries() {
      const entries = [
        ...this.normalize(this.priceBreakdown, ''),
        ...this.normalize(this.childBreakdown, ''),
      ]
      if (this.includeDaily) entries.push(...this.normalize(this.daily, 'Diária'))

      return entries
    },
  },
  methods: {
    normalize(value, group) {
      if (!value) return []
      if (typeof value === 'string') return [{ group, label: value, amount: null }]
      if (!Array.isArray(value)) {
        return Object.keys(value).map(key => this.normalizeItem(value[key], group, key))
      }

      return value.map((item, index) => this.normalizeItem(item, group, String(index + 1)))
    },
    normalizeItem(item, group, fallbackLabel) {
      if (item === null || item === undefined) {
        return { group, label: fallbackLabel, amount: null }
      }
      if (typeof item !== 'object') {
        return { group, label: fallbackLabel, amount: item }
      }
      const label = item.label || item.name || item.description || item.date || item.title || fallbackLabel
      const amountKeys = ['formatted_value', 'formatted_amount', 'total', 'amount', 'value', 'price']
      const amountKey = amountKeys.find(key => item[key] !== undefined && item[key] !== null)
      const detail = item.detail || item.composition || item.policy_label

      return {
        group,
        label: detail ? `${label} (${detail})` : label,
        amount: amountKey ? item[amountKey] : null,
      }
    },
    formatAmount(value) {
      if (typeof value === 'string' && /R\$/.test(value)) return value
      const number = Number(value)
      if (Number.isNaN(number)) return String(value)

      return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
  },
}
</script>

<style scoped>
.price-breakdown {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 0.78rem;
  color: #4b5563;
}

.price-breakdown__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.price-breakdown__amount {
  white-space: nowrap;
  font-weight: 600;
}
</style>
